import { createContext, useCallback, useContext, useState } from 'react';
import Dialog from './Dialog';
import LoadingBackdrop from '../../Components/LoadingBackdrop/LoadingBackdrop';
import { Txt, useTxt } from '../../Routes/Localized';

const DialogContext = createContext(null);

export const DialogManager = ({ children }) => {
    const [dialog, setDialog] = useState(null);
    const [loading, setLoading] = useState(false);
    const txt = useTxt();

    const setDialogError = () => {
        setDialog(<Txt id="default:779066" />);
    }

    const setDialogState = useCallback((...args) => {
        if (args.length === 0 || !args[0]) {
            setDialog(null);
            return;
        }

        const [first] = args;

        if (args.length === 1 && typeof first === 'object' && !Array.isArray(first)) {
            setDialog(first);
            return;
        }

        const unifiedMessage = args
            .filter(arg => arg !== null && arg !== undefined)
            .map(arg => {
                if (typeof arg === 'object') {
                    return arg.message || arg.toString();
                }
                return String(arg);
            })
            .join(" ");

        setDialog(unifiedMessage);
    }, []);

    return (
        <DialogContext.Provider value={{ dialog, setDialog, loading, setLoading, setDialogError }}>
            <Dialog dialog={dialog} setDialog={setDialogState} />
            <LoadingBackdrop open={loading} />
            {children}
        </DialogContext.Provider>
    );
};

export const useDialog = () => useContext(DialogContext);
